import React, { Suspense } from 'react';
import { Spin, message, ConfigProvider, notification, Modal } from 'antd';
import moment from 'moment'
import Login from '../login/Login';
import PageIndex from '../index/index';
import HomePage from '../homePage/index';
import DataView from '../dataView/dataView';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import $ from '../../scripts/events'
import '../../scripts/config';
import 'antd/dist/antd.css';
import './index.css';
import zhCN from 'antd/es/locale/zh_CN';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
let $this;
let _userModal;
let _timer;
let _st;
let _zxsj = 1800000;//标准自动注销时间(30分钟)
let _dm_xtgl_xtsz;
class TopContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            topContainer: {
                pageName: 'login'
            },
            objUser: {},
            wslink: false,
            wsobj: {}
        }
        $this = this;
        //#region  全局监听
        //重新登录
        this.eventEmitter = $.addListener("reLogin", (param) => {
            this.emitHandler('reLogin', param);
        });
        //返回首页
        this.eventEmitter = $.addListener("goHomePage", (param) => {
            this.emitHandler('goHomePage', param);
        });
        //更新数据字典
        this.eventEmitter = $.addListener("DictionariesUpdate", (param) => {
            this.emitHandler('DictionariesUpdate', param);
        });
        //加载数据字典
        this.eventEmitter = $.addListener("DictionariesLoad", (param) => {
            this.emitHandler('DictionariesLoad', param);
        });
        //初始化数据字典
        this.eventEmitter = $.addListener("DictionariesInit", (param) => {
            this.emitHandler('DictionariesInit', param);
        });

        //回车监听
        window.onkeydown = function (event) {
            let e = event || window.event;
            $this.userHandler();
        };
        //鼠标点击监听
        window.onclick = function (event) {
            $this.userHandler();
        };
        window.onscroll = function () {
            $this.userHandler();
        }
        window.onmousemove = function () {
            $this.userHandler();
        }
        //#endregion

        let _xtsz = localStorage.getItem('DictionariesXtsz');
        _dm_xtgl_xtsz = _xtsz === '' || _xtsz === null || _xtsz === undefined ? [] : JSON.parse(_xtsz);
        this.sjzdDataRead(_dm_xtgl_xtsz, 'pub_relogin', (dqz) => {
            const _number = dqz !== '' && dqz !== null && dqz !== undefined ? parseInt(dqz) * 60000 : _zxsj;
            this.userHandler = debounce(this.userHandler, _number);
        });
    }
    //服务通信连接
    socketInit = () => {
        let wsImpl = window.WebSocket || window.MozWebSocket;
        // 创建新的websocket新连接端口为7181
        window.ws = new wsImpl(global.constants.socketaddress);

        // 当数据从服务器服务中心发送后，继续向下运行过程
        window.ws.onmessage = function (evt) {
            let obj = JSON.parse(evt.data);
            if (obj.StatusCode === 'init') {
                $this.setState({ wslink: true, wsobj: obj });
                setTimeout(() => {
                    $this.emitHandler('updatewsobj', { UserType: 'PC', UserId: $this.state.objUser.czyid || '', UserName: $this.state.objUser.xm || '', yhid: $this.state.objUser.yhid || '' });
                }, 200);
            }
            else if (obj.StatusCode === 'login') {
                message.success('识别成功,正在登录...');
                setTimeout(() => {
                    $this.$ChildLoginPage.loginWrite(JSON.parse(obj.Content));//登录
                }, 1200);
            }
            else if (obj.StatusCode === 'message') {
                notification.info({
                    message: '消息提醒',
                    description: obj.Content,
                    placement: 'bottomRight',
                    duration: 3
                })
            }
            else if (obj.StatusCode === 'process') {
                notification.info({
                    message: '进度提醒',
                    description: obj.Content,
                    placement: 'bottomRight',
                    duration: 1
                })
            }
            else if (obj.StatusCode === 'wsmethod') {
                //#region 需要执行的方法
                $this.wsmethodback(obj.Content);
                //#endregion
            }
        };
        // 当链接对象找到服务端成功对接后，提示正常打开
        window.ws.onopen = function () {
            $this.setState({ wslink: true });
        };
        // 当链接对象未找找到服务端成功对接后，提示打开失败，别切单项关闭
        window.ws.onclose = function () {
            $this.setState({ wslink: false });
        }
    }
    //渲染完成
    componentDidMount() {
        //debug 有时候需要强制重新登录 
        const _userStorage = localStorage.getItem('userStorage');
        let _update = true;
        if (_userStorage !== '' && _userStorage !== null && _userStorage !== undefined) {
            const { loadLocalStorage } = this.props;
            const _objPage = JSON.parse(localStorage.getItem('objPage'));
            const _userObj = JSON.parse(_userStorage);
            let _last_modified = _userObj.last_modified;
            if (_last_modified === null || _last_modified === undefined) {
                _update = false;
                //超期重新登录
                this.emitHandler('reLogin');
            }
            else {
                //获取配置的有效登陆时长
                this.sjzdDataRead(_dm_xtgl_xtsz, 'pub_login', (dqz) => {
                    const _number = dqz !== '' && dqz !== null && dqz !== undefined ? parseInt(dqz) : 6;
                    const _yxdate = moment(_last_modified).add(_number, 'hours');
                    if (_yxdate.isBefore(moment())) {
                        _update = false;
                        //超期重新登录
                        this.emitHandler('reLogin');
                    }
                });
            }
            if (_update) {
                this.setState({ objUser: _userObj });
                //更新store信息
                loadLocalStorage({ type: 'objUser', data: _userObj });
                loadLocalStorage({ type: 'topContainer', data: _objPage });
                //误操作监听
                this.userHandler();
            }
        }
        setTimeout(() => {
            this.socketInit();
        }, 2000);
    }
    ///用户动作监听
    userHandler = () => {
        setTimeout(() => {
            this.userExit();
        }, 10000);
    }
    userExit = () => {
        const { store } = this.props;
        if (store.topContainer.pageName !== 'login') {
            let secondsToGo = 5;
            _userModal = Modal.warning({
                title: '系统休眠提醒',
                content: `身份将在 ${secondsToGo} 秒后自动注销并退出.`,
                okText: '等会儿',
                onOk: () => {
                    clearTimeout(_st);
                    clearInterval(_timer);
                    _userModal.destroy();
                    $this.userHandler();
                }
            });
            _timer = setInterval(() => {
                secondsToGo -= 1;
                _userModal.update({
                    content: `身份将在 ${secondsToGo} 秒后自动注销并退出.`,
                });
            }, 1000);
            _st = setTimeout(() => {
                clearInterval(_timer);
                _userModal.destroy();
                this.emitHandler('reLogin', null);
                setTimeout(() => {
                    $this.userHandler();
                }, 10000);
            }, secondsToGo * 1000);
        }
        else {
            _st = setTimeout(() => {
                $this.userHandler();
            }, 10000);
        }
    }
    //数据字典值读取
    sjzdDataRead = (xtsz, dm, fn) => {
        let _dqz = '';
        if (xtsz.list !== null && xtsz.list !== undefined) {
            if (xtsz.list.length > 0) {
                const list = xtsz.list[0];
                list.map(item => {
                    if (item.dm === dm) {
                        _dqz = item.dqz;
                        return;
                    }
                });
            }
        }
        if (fn) {
            fn(_dqz);
        }
    }
    //重新登录
    emitHandler = (type, param) => {
        const { loadLocalStorage } = this.props;
        if (type === 'reLogin') {
            //清除存储信息
            const _userStorage = localStorage.getItem('userStorage');
            if (_userStorage !== '' && _userStorage !== null && _userStorage !== undefined) {
                const _userObj = JSON.parse(_userStorage);
                const _userName = _userObj.userName;
                const _userNameCN = _userObj.xm;
                const _czy_ksid = _userObj.czy_ksid;
                localStorage.setItem('userStorage', JSON.stringify({ userName: _userName, userNameCN: _userNameCN, czy_ksid: _czy_ksid }));
                localStorage.setItem('objPage', JSON.stringify({ pageName: 'login' }));
            }
            if (this.state.wslink) {
                let _obj = this.state.wsobj;
                let _wsobj = Object.assign(_obj, param);
                //给通信服务器发送消息更新自己的状态
                _wsobj.Status = '0';
                _wsobj.StatusCode = 'exit';//退出
                window.ws.send(JSON.stringify(_wsobj));
            }
            //更新store信息
            loadLocalStorage({ type: 'objUser', data: {} });
            loadLocalStorage({ type: 'topContainer', data: { pageName: 'login' } });
            loadLocalStorage({
                type: 'homePageInit', data: {
                    mkMenu: {},
                    footerMenu: []
                }
            });

            try {
                $this.$ChildLoginPage.wsObjWrite({ wslink: this.state.wslink, wsobj: this.state.wsobj });//登录
            }
            catch (e) {

            }
        }
        else if (type === 'goHomePage') {
            //更新store信息
            localStorage.setItem('objPage', JSON.stringify({ pageName: 'homePage', mkmc: '' }));
            loadLocalStorage({ type: 'topContainer', data: { pageName: 'homePage' } });
        }
        else if (type === 'DictionariesUpdate') {
            //初始化字典
            this.DictionariesUpdate(param);
        }
        else if (type === 'DictionariesLoad') {
            //本地数据获取更新store
            this.DictionariesLoad(param);
        }
        else if (type === 'DictionariesInit') {
            //判断是否有数据字典
            this.DictionariesInit(param);
        }
        else if (type === 'wsobj') {
            return { wslink: this.state.wslink, wsobj: this.state.wsobj };
        }
        else if (type === 'updatewsobj') {
            let _obj = this.state.wsobj;
            let _wsobj = Object.assign(_obj, param);
            this.setState({ wsobj: _wsobj });
            if (this.state.wslink) {
                //给通信服务器发送消息更新自己的状态
                _wsobj.Status = '1';
                _wsobj.UserType = 'PC';
                _wsobj.StatusCode = 'refresh';//更新数据库信息
                window.ws.send(JSON.stringify(_wsobj));
            }
            try {
                if ($this.$ChildLoginPage) {
                    $this.$ChildLoginPage.wsObjWrite({ wslink: this.state.wslink, wsobj: this.state.wsobj });//登录
                }
            }
            catch (e) {

            }
        }
        else if (type === 'changewsobj') {
            //给通信服务发送新身份
            let _obj = this.state.wsobj;
            const _objUser = this.state.objUser;
            let _wsobj = Object.assign(_obj, param);
            this.setState({ wsobj: _wsobj });
            if (this.state.wslink) {
                //给通信服务器发送消息新增自己的状态
                _wsobj.Status = '1';
                _wsobj.UserId = _objUser.czyid;
                _wsobj.UserName = _objUser.dwid;
                _wsobj.UserType = param.UserType || 'TEJH';
                _wsobj.StatusCode = 'refresh';//更新数据库信息
                window.ws.send(JSON.stringify(_wsobj));
            }
        }
        else if (type === 'wsmethod') {
            let _obj = this.state.wsobj;
            let _wsobj = Object.assign(_obj, param);
            if (this.state.wslink) {
                _wsobj.ToUserType = "CL";
                _wsobj.ToUserId = _wsobj.UserId;
                //给通信服务器发送消息更新自己的状态
                window.ws.send(JSON.stringify(_wsobj));
            }
        }
        else if (type === 'userHandler') {
            this.userHandler();
        }
    }
    //ws通信数据返回
    wsmethodback = (content) => {
        try {
            const Obj = JSON.parse(content);
            const _method = Obj.method;
            $.emit(_method, Obj);
        }
        catch (e) {
            message.error(e);
        }
    }
    //字典初始化
    DictionariesInit = (param) => {
        const _page = param.pageName;
        const { loadLocalStorage } = this.props;
        //数据字典初始化
        if (_page === 'index') {
            let _indexPageSuccess = localStorage.getItem('indexPageSuccess');
            let _indexPageSuccessTime = localStorage.getItem('indexPageSuccessTime');
            if (_indexPageSuccess === 'True' || _indexPageSuccess === true || _indexPageSuccess === 'true') {
                //日期比较
                const _dte = moment(_indexPageSuccessTime, "YYYYMMDD").fromNow();
                if (_dte.indexOf('ago') > -1 || _dte.indexOf('前') > -1) {
                    loadLocalStorage({ type: 'DictionariesState', data: { indexPageSuccess: true, indexPageSuccessTime: moment().format('YYYYMMDD') } });//字典状态更新
                    //更新主页数据字典
                    this.DictionariesLoad(param);
                }
            }
            else {
                //更新主页数据字典
                this.DictionariesLoad(param);
            }
        }
        else {
            let _homePageSuccess = localStorage.getItem('homePageSuccess');
            if (_homePageSuccess === 'True' || _homePageSuccess === true || _homePageSuccess === 'true') {
                loadLocalStorage({ type: 'DictionariesState', data: { homePageSuccess: true, homePageSuccessTime: moment().format('YYYYMMDD') } });//字典状态更新
                //更新首页数据字典
                this.DictionariesLoad(param);
            }
        }
    }
    //数据字典更新
    DictionariesUpdate = (param) => {
        //更新分为store更新和本地存储更新
        const { loadLocalStorage } = this.props;
        if (param.pageName === 'homePage') {
            loadLocalStorage({ type: 'DictionariesState', data: { homePageSuccess: false } });//字典状态更新
        }
        else {
            loadLocalStorage({ type: 'DictionariesState', data: { indexPageSuccess: false } });//字典状态更新
        }
    }
    //获取本地存储字典信息
    DictionariesLoad = (param) => {
        const { loadLocalStorage } = this.props;
        const _page = param.pageName;
        if (_page === 'index') {
            //重载业务字典
            try {
                let _dm_xtgl_sjzd = localStorage.getItem('DictionariesSjzd');
                let _dm_xtgl_xtsz = localStorage.getItem('DictionariesXtsz');
                let _dm_xtgl_dw_rydm = localStorage.getItem('DictionariesRydm');
                let _dm_xtgl_ks_rydm = localStorage.getItem('DictionariesKsRydm');
                let _dm_xtgl_ksdm = localStorage.getItem('DictionariesKsdm');
                let _dm_xtgl_glmk = localStorage.getItem('DictionariesGlmk');
                loadLocalStorage({ type: 'DictionariesSjzd', data: JSON.parse(_dm_xtgl_sjzd) });
                loadLocalStorage({ type: 'DictionariesXtsz', data: JSON.parse(_dm_xtgl_xtsz) });
                loadLocalStorage({ type: 'DictionariesRydm', data: JSON.parse(_dm_xtgl_dw_rydm) });
                loadLocalStorage({ type: 'DictionariesKsRydm', data: JSON.parse(_dm_xtgl_ks_rydm) });
                loadLocalStorage({ type: 'DictionariesKsdm', data: JSON.parse(_dm_xtgl_ksdm) });
                loadLocalStorage({ type: 'DictionariesGlmk', data: JSON.parse(_dm_xtgl_glmk) });
                localStorage.setItem('indexPageSuccess', true);
                localStorage.setItem('indexPageSuccessTime', moment().format('YYYYMMDD'));
            }
            catch (e) {
                message.error(e, 6);
            }
        }
        else {
            //重载通用字典
            try {
                let _dm_xtgl_xzdq = localStorage.getItem('DictionariesXzdq');
                let _dm_xtgl_xzdq_xq = localStorage.getItem('DictionariesXzdqXq');
                let _dm_xtgl_dwdm = localStorage.getItem('DictionariesDwdm');
                let _dm_xtgl_dwdm_xq = localStorage.getItem('DictionariesDwdmXq');
                loadLocalStorage({ type: 'DictionariesXzdq', data: JSON.parse(_dm_xtgl_xzdq) });
                loadLocalStorage({ type: 'DictionariesXzdqXq', data: JSON.parse(_dm_xtgl_xzdq_xq) });
                loadLocalStorage({ type: 'DictionariesDwdm', data: JSON.parse(_dm_xtgl_dwdm) });
                loadLocalStorage({ type: 'DictionariesDwdmXq', data: JSON.parse(_dm_xtgl_dwdm_xq) });
                localStorage.setItem('homePageSuccess', true);
                localStorage.setItem('homePageSuccessTime', moment().format('YYYYMMDD'));
            }
            catch (e) {
                message.error(e, 6);
            }
        }

    }

    render() {
        const { store } = this.props;
        return (
            <div style={{ width: '100%', height: '100%', overflowX: 'hidden' }}>
                <ConfigProvider locale={zhCN}>
                    <Suspense fallback={<Spin size="large" />}>
                        {store.topContainer.pageName === 'index' ?
                            <PageIndex emitHandler={this.emitHandler}></PageIndex> :
                            store.topContainer.pageName === 'homePage' ?
                                <HomePage emitHandler={this.emitHandler} onRef={(ref) => { this.$ChildHomePage = ref }}></HomePage> :
                                store.topContainer.pageName === 'dataView' ?
                                    <DataView emitHandler={this.emitHandler} onRef={(ref) => { this.$ChildHomePage = ref }}></DataView> :
                                    <Login emitHandler={this.emitHandler} onRef={(ref) => { this.$ChildLoginPage = ref }}></Login>}
                    </Suspense>
                </ConfigProvider>
            </div >
        );
    }
}

//需要渲染什么数据
function mapStateToProps(state) {
    return {
        store: state
    }
}
//需要触发什么行为
function mapDispatchToProps(dispatch) {
    return {
        loadLocalStorage: (data) => dispatch({
            type: data.type, data: data.data
        })
    }
}

//连接组件
TopContainer = connect(mapStateToProps, mapDispatchToProps)(TopContainer)
export default TopContainer;